import {
  BMP_HEADER_BYTES,
  OpenImageViewerError,
  OpenImageViewerShell,
  parseBmpHeader,
  readFileHeader,
  type OpenImageViewerConfig,
} from '@/features/open-image-viewer'
import { useT } from '@/shared/i18n'

const MAX_PIXELS = 36_000_000

export function BmpViewerPage() {
  const t = useT()
  const copy = t.bmpViewer
  const config: OpenImageViewerConfig = {
    analyticsContext: {
      app: 'imgify',
      domain: 'imgify.ru',
      route: '/otkryt-bmp',
      utility: 'bmp-viewer',
      processingMode: 'local',
    },
    accept: '.bmp,.dib,image/bmp,image/x-ms-bmp',
    acceptedMimeTypes: ['image/bmp', 'image/x-ms-bmp'],
    acceptedExtensions: ['.bmp', '.dib'],
    maxFileSizeBytes: 50 * 1024 * 1024,
    maxPixels: MAX_PIXELS,
    formatLabel: 'BMP',
    validateFile: async (file) => {
      const header = parseBmpHeader(await readFileHeader(file, BMP_HEADER_BYTES))
      if (!header) return false
      if (header.width * header.height > MAX_PIXELS) {
        throw new OpenImageViewerError(copy.errorsText.too_large_image, 'too_large_image')
      }
      return true
    },
    exportFormats: ['png', 'jpg'],
    relatedTools: copy.relatedTools,
  }

  return <OpenImageViewerShell copy={copy} config={config} />
}
